import { render, staticRenderFns } from "./SectionAllChannels.vue?vue&type=template&id=35f69b74&scoped=true&"
import script from "./SectionAllChannels.vue?vue&type=script&lang=js&"
export * from "./SectionAllChannels.vue?vue&type=script&lang=js&"
import style0 from "./SectionAllChannels.vue?vue&type=style&index=0&id=35f69b74&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f69b74",
  null
  
)

export default component.exports